// Help is an independent entry so an account or sign-in outage cannot block it.
// Do not start analytics/session replay on pages containing private support conversations.
if (/^\/(help|support)\/?$/.test(window.location.pathname)) {
  const fragment = new URLSearchParams(window.location.hash.slice(1));
  const initialLink = { token: fragment.get('access'), ticketId: fragment.get('ticket'), requests: fragment.has('requests') };
  if (initialLink.token) {
    fragment.delete('access');
    const hash = fragment.toString();
    window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}${hash ? `#${hash}` : ''}`);
  }
  import('./support-app-entry').then(({ renderSupport }) => renderSupport(initialLink));
} else {
  import('./application-main');
}
